import seoMarketConfig from './seoMarkets.json';

export interface SeoMarket {
  name: string;
  latitude: number;
  longitude: number;
}

export const SEO_MARKETS: SeoMarket[] = seoMarketConfig.seoMarkets;
export const SEO_MARKET_RADIUS_MILES = seoMarketConfig.seoMarketRadiusMiles;
